<template>
  <div class="teacher-report-container">
    <Forbidden v-if="getUserRole[getUserRole.length - 1].role_id == 0" routerPath="notLogin" />
    <Forbidden
      v-else-if="getUserRole[getUserRole.length - 1].role_id != userRole.TEACHER"
      routerPath="incorrectRole"
    />
    <Forbidden v-else-if="!getClassPeriodOpened" routerPath="notInPeriod" />
    <section class="teacher-report-container vector-background col v-center">
      <div class="header-wrapper mt-5 mb-4">
        <h3 class="header-title">Laporan Penilaian</h3>
        <button class="tambah-laporan btn primary" @click="isModal = !isModal">+</button>
      </div>
      <div class="table-container">
        <div class="table-wrapper" v-if="laporanPeserta.length !== 0">
          <table id="table-peserta-report" aria-describedby="table-calon-peserta">
            <tr>
              <th scope="col">Nama</th>
              <th scope="col">Juz</th>
              <th scope="col">Dari Surah : Ayat / Sampai Surah : Ayat</th>
              <th scope="col">Nilai</th>
              <th scope="col">Catatan</th>
              <th scope="col">Keterangan</th>
            </tr>
            <tr v-for="(data, index) in laporanPeserta" :key="index">
              <td>{{ data.displayName }}</td>
              <td class="v-center">{{ data.juz }}</td>
              <td class="v-center">
                {{
                data.fromSurah +
                ":" +
                data.fromAyat +
                " / " +
                data.toSurah +
                ":" +
                data.toAyat
                }}
              </td>
              <td class="v-center">{{ data.score }}</td>
              <td>{{ data.note }}</td>
              <td class="v-center">
                <button class="btn" @click="editReport(data)">Ubah</button>
              </td>
            </tr>
          </table>
        </div>
        <b-row v-else class="not-available-container" align-v="center">
          <p text-center>Laporan belum dimasukkan untuk periode ini.</p>
        </b-row>
      </div>
      <b-modal
        v-model="isModal"
        class="modal"
        size="md"
        hide-footer
        centered
        no-close-on-backdrop
        header-class="no-header"
      >
        <div class="custom-modal-header">
          <h4 class="header-title">Detail Pilihan</h4>
          <div class="close" @click="cancelAdd">×</div>
        </div>
        <div class="modal-content">
          <b-form>
            <b-row>
              <b-col>
                <b-form-group id="session-group" label="Jadwal" label-for="session">
                  <div v-if="form.edit">
                    <b-form-select
                      id="session"
                      v-model="form.session"
                      :options="scheduleEditOption"
                      :state="validateState('session')"
                      aria-describedby="session-live-feedback"
                      required
                    >
                      <template v-slot:first>
                        <b-form-select-option value disabled>Pilih Opsi</b-form-select-option>
                      </template>
                    </b-form-select>
                    <b-form-invalid-feedback id="session-live-feedback" class="error_session">
                      Pilih jadwal peserta dengan
                      benar
                    </b-form-invalid-feedback>
                  </div>
                  <div v-else>
                    <b-form-select
                      id="schedule"
                      v-model="form.session"
                      :options="scheduleOption"
                      :state="validateState('session')"
                      aria-describedby="session-live-feedback"
                      required
                    >
                      <template v-slot:first>
                        <b-form-select-option value disabled>Pilih Opsi</b-form-select-option>
                      </template>
                    </b-form-select>
                    <b-form-invalid-feedback id="session-live-feedback" class="error_session">
                      Pilih jadwal peserta dengan
                      benar
                    </b-form-invalid-feedback>
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group id="juz-group" label="Juz" label-for="juz">
                  <b-form-select
                    id="juz"
                    v-model="form.juz"
                    :options="juzOption"
                    required
                    @change="retrieveSurah()"
                    :state="validateState('juz')"
                    aria-describedby="juz-live-feedback"
                  >
                    <template v-slot:first>
                      <b-form-select-option value disabled>Pilih Opsi</b-form-select-option>
                    </template>
                  </b-form-select>
                  <b-form-invalid-feedback
                    id="juz-live-feedback"
                    class="error_juz"
                  >Masukkan juz dengan benar</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12" md="6">
                <b-form-group id="fromSurah-group" label="Dari Surah" label-for="surah">
                  <b-form-select
                    id="fromSurah"
                    v-model="form.fromSurah"
                    :options="surahOption"
                    required
                    :state="validateState('fromSurah')"
                    aria-describedby="fromSurah-live-feedback"
                  >
                    <template v-slot:first>
                      <b-form-select-option value disabled>Pilih Opsi</b-form-select-option>
                    </template>
                  </b-form-select>
                  <b-form-invalid-feedback
                    id="fromSurah-live-feedback"
                    class="error_fromSurah"
                  >Masukkan surah dengan benar</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col sm="12" md="6">
                <b-form-group id="fromAyat-group" label="Dari Ayat" label-for="fromAyat">
                  <b-form-input
                    id="fromAyat"
                    size="sm"
                    type="number"
                    v-model="form.fromAyat"
                    placeholder="Masukkan target ayat"
                    :state="validateState('fromAyat')"
                    aria-describedby="fromAyat-live-feedback"
                  ></b-form-input>
                  <b-form-invalid-feedback
                    id="fromAyat-live-feedback"
                    class="error_fromAyat"
                  >Masukkan ayat dengan benar</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12" md="6">
                <b-form-group id="toSurah-group" label="Sampai Surah" label-for="toSurah">
                  <b-form-select
                    id="toSurah"
                    v-model="form.toSurah"
                    :options="surahOption"
                    required
                    :state="validateState('toSurah')"
                    aria-describedby="toSurah-live-feedback"
                  >
                    <template v-slot:first>
                      <b-form-select-option value disabled>Pilih Opsi</b-form-select-option>
                    </template>
                  </b-form-select>
                  <b-form-invalid-feedback
                    id="toSurah-live-feedback"
                    class="error_toSurah"
                  >Masukkan surah dengan benar</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col sm="12" md="6">
                <b-form-group id="toAyat-group" label="Sampai Ayat" label-for="toAyat">
                  <b-form-input
                    id="toAyat"
                    size="sm"
                    type="number"
                    v-model="form.toAyat"
                    placeholder="Masukkan target ayat"
                    :state="validateState('toAyat')"
                    aria-describedby="toAyat-live-feedback"
                  ></b-form-input>
                  <b-form-invalid-feedback
                    id="toAyat-live-feedback"
                    class="error_toAyat"
                  >Masukkan ayat dengan benar</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group id="score-group" label="Nilai" label-for="score">
                  <b-form-input
                    id="score"
                    size="sm"
                    type="number"
                    v-model="form.score"
                    placeholder="Masukkan nilai peserta"
                    :state="validateState('score')"
                    aria-describedby="score-live-feedback"
                  ></b-form-input>
                  <b-form-invalid-feedback
                    id="score-live-feedback"
                    class="error_score"
                  >Masukkan nilai dengan benar</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group id="note-group" label="Catatan" label-for="note">
                  <b-form-textarea
                    id="note"
                    v-model="form.note"
                    placeholder="Masukkan catatan kamu di sini..."
                    rows="3"
                    max-rows="4"
                    :state="validateState('note')"
                    aria-describedby="note-live-feedback"
                  ></b-form-textarea>
                  <b-form-invalid-feedback
                    id="note-live-feedback"
                    class="error_note"
                  >Masukkan catatan dengan benar</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </div>
        <div class="modal-footer" v-if="form.edit">
          <button v-b-modal.konfirmasi-hapus class="btn danger">Delete</button>
          <button @click="onSubmit" class="btn primary">Ubah</button>
        </div>
        <div class="modal-footer" v-else>
          <button @click="cancelAdd" class="btn">Batal</button>
          <button @click="onSubmit" class="btn primary">Tambah</button>
        </div>
        <b-modal id="konfirmasi-hapus" size="sm" hide-footer title="Konfirmasi untuk menghapus">
          <p class="my-2">Apakah anda yakin untuk menghapus laporan ini ?</p>
          <div class="modal-footer">
            <button @click="cancelAdd" class="btn">Batal</button>
            <b-button @click="deleteReport" class="btn danger">Hapus</b-button>
          </div>
        </b-modal>
      </b-modal>
    </section>
  </div>
</template>

<script>
import { required, numeric, minValue, between } from "vuelidate/lib/validators";
import User from "@/services/User";
import { mapGetters } from "vuex";
import moment from "moment/moment";
import Forbidden from "@/views/Forbidden.vue";
import QuranDict from "@/services/QuranDict";
import { UserRole } from "@/services/StatusCode";

export default {
  name: "TeacherReport",
  components: {
    Forbidden
  },
  data() {
    return {
      isModal: false,
      laporanPeserta: [],
      form: {
        edit: false,
        id: "",
        displayName: "",
        session: "",
        juz: "",
        fromSurah: "",
        toSurah: "",
        fromAyat: "",
        toAyat: "",
        score: 0,
        note: ""
      },
      fromAyat: "",
      toAyat: "",
      fromSurah: "",
      toSurah: "",
      scheduleOption: [],
      scheduleEditOption: [],
      surahOption: [],
      juzOption: Object.keys(QuranDict),
      userRole: UserRole
    };
  },
  validations: {
    form: {
      session: {
        required
      },
      juz: {
        required,
        numeric,
        between: between(1, 30)
      },
      fromSurah: {
        required
      },
      toSurah: {
        required
      },
      fromAyat: {
        numeric,
        minValue: minValue(1)
      },
      toAyat: {
        numeric,
        minValue: minValue(1)
      },
      score: {
        required,
        numeric,
        minValue: minValue(0)
      },
      note: {
        required
      }
    }
  },
  methods: {
    resetForm() {
      this.form = {
        edit: false,
        id: "",
        displayName: "",
        session: "",
        juz: "",
        fromSurah: "",
        toSurah: "",
        fromAyat: 0,
        toAyat: 0,
        score: 0,
        note: ""
      };
    },
    cancelAdd() {
      this.isModal = false;
      this.form.edit = false;
      this.resetForm();
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      } else {
        this.addReport();
      }
    },
    addReport() {
      User.sendTeacherReport(
        process.env.VUE_APP_URL,
        this.getAccessToken,
        this.form
      )
        .then(() => {
          this.getTeacherReport();
          this.getSchedule();
        })
        .finally(() => {
          this.isModal = false;
          this.resetForm();
        });
    },
    deleteReport() {
      User.deleteTeacherReport(
        process.env.VUE_APP_URL,
        this.getAccessToken,
        this.form
      )
        .then(() => {
          this.getTeacherReport();
          this.getSchedule();
        })
        .finally(() => {
          this.isModal = false;
          this.resetForm();
        });
    },
    editReport(data) {
      this.isModal = true;
      this.form = data;
      this.form.edit = true;
    },
    async getSchedule() {
      await User.getTeacherSchedule(
        process.env.VUE_APP_URL,
        this.getAccessToken,
        this.getTermName
      ).then(response => {
        const listEditSchedule = [];
        const listSchedule = [];
        response.forEach(data => {
          if (data.student != null) {
            this.form.displayName = data.student.full_name;
            const formattedStartDate = moment(data.start_datetime);
            const formattedEndDate = moment(data.end_datetime);
            const nowDatetime = moment();
            if (nowDatetime.isAfter(formattedEndDate)) {
              if (
                this.laporanPeserta.find(({ session }) => session == data.id) ==
                undefined
              ) {
                listSchedule.push({
                  value: Number(data.id),
                  text:
                    formattedStartDate.format("DD MMMM YYYY, HH:MM") +
                    " - " +
                    this.form.displayName,
                  disabled: false
                });
                this.scheduleOption = listSchedule;
              } else {
                listEditSchedule.push({
                  value: Number(data.id),
                  text:
                    formattedStartDate.format("DD MMMM YYYY, HH:MM") +
                    " - " +
                    this.form.displayName,
                  disabled: true
                });
                this.scheduleEditOption = listEditSchedule;
              }
            }
          }
        });
      });
    },
    async getTeacherReport() {
      await User.getTeacherReport(
        process.env.VUE_APP_URL,
        this.getAccessToken,
        this.getTermName
      ).then(response => {
        const tempLaporanPeserta = [];
        response.reports.forEach(data => {
          tempLaporanPeserta.push({
            edit: false,
            id: data.report_id,
            displayName: data.student,
            session: data.schedule_id,
            juz: data.juz,
            fromSurah: data.surah.split("/")[0].split(":")[0],
            fromAyat: data.surah.split("/")[0].split(":")[1],
            toSurah: data.surah.split("/")[1].split(":")[0],
            toAyat: data.surah.split("/")[1].split(":")[1],
            score: data.score,
            note: data.note
          });
        });
        this.laporanPeserta = tempLaporanPeserta;
      });
    },
    retrieveSurah() {
      const selectedJuz = this.form.juz;
      this.surahOption = QuranDict[selectedJuz];
    }
  },
  mounted() {
    if (
      this.getUserRole[this.getUserRole.length - 1].role_id != 0 &&
      this.getUserRole[this.getUserRole.length - 1].role_id ==
        UserRole.TEACHER &&
      this.getClassPeriodOpened
    ) {
      this.getTeacherReport();
      this.getSchedule();
    }
  },
  computed: {
    ...mapGetters({
      getAccessToken: "getAccessToken",
      getTermName: "getTermName",
      getUserRole: "getUserRole",
      getClassPeriodOpened: "getClassPeriodOpened"
    })
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/form.scss";
@import "@/styles/reusable/table.scss";

.teacher-report-container {
  min-height: inherit;
}

.header-wrapper {
  display: flex;
  align-items: center;

  .header-title {
    margin-right: $gap-sm-4;
  }
}

.header-title {
  text-align: center;
  color: #000;
  font-weight: bold;
}

.custom-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: $gap-sm-4 $gap-sm-2;

  .close {
    pointer-events: visible;
    cursor: pointer;
  }
}
</style>
